// Model id helpers shared by client hooks and server code. Model ids are
// dynamic (sourced from the global_models table), so this is a string alias.

export type ModelId = string;

export const DEFAULT_MODEL: ModelId = "claude-sonnet-5";

export const isValidModelId = (id: unknown): id is ModelId =>
  typeof id === "string" && id.trim().length > 0;
